import { z } from 'zod';
import { ModelDefinition } from '../base-components/hooks/useModel';
import { getProduct, saveProduct, createProductAndGetId } from '../api/product-controller';
import { RoutePath } from '@/generic/config';

export const ProductSchema = z.object({
    id: z.number(),
    code: z.string(),
    enabled: z.boolean(),
});

type Product = z.infer<typeof ProductSchema>;

export default Product;

export const emptyProductObject: Product = {
    id: 0,
    code: "",
    enabled: true,
};

export const ProductModel: ModelDefinition<Product> = {
    getById: getProduct,
    saveFromModel: saveProduct,
    createFromModel: createProductAndGetId,
    validationMessages: () => [],
    routePath: RoutePath.Products,
    typeProviderObject: ProductSchema.parse(emptyProductObject),
};